import React, { Component } from 'react';
import { CreditDetails, Stepper, Card, Footer } from '../common';
import { RadioGroup, Heading, Textarea, Loader } from '../../../../../UiKit';
import {
  getFormData,
  checkIfOptional,
} from '../../../../commons/CommonMethods';
import { reasonModel } from '../../../../../api';
import ActionOptions from '../../ActionOptions/ActionOptions';
import SuccessScreen from '../../ActionOptions/SuccessScreen';
import { EmptyState } from '../../../../commons';
import { InvalidSearchImg } from '../../../../../images/images';

export default class OrderNotDelivered extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditsBodyParams: null,
      radio: null,
      selectedRadioOption: '',
      creditOptions: null,
      showCreditOptionsTemp: false,
      stepperData: null,
      showOptionalError: false,
      optionalErrorText: '',
      comment: '',
      showRadio: false,
      showResolutionOptions: false,
      resolutionOptionDetails: {},
      showSuccessScreen: false,
      resolutionSuccessDetails: {},
      isError: false,
      isLoading: false,
      errorMessage: '',
    };
    this.timerId1 = null;
    this.timerId2 = null;
  }

  componentWillUnmount = () => {
    clearTimeout(this.timerId1);
    clearTimeout(this.timerId2);
  };

  addComment = (event) => {
    this.setState({
      comment: event.target.value,
      showOptionalError: false,
    });
  };

  sendFormData = (urlStr, params) => {
    const { issueInfo, orderId, reasonId, sendFormData } = this.props;
    const { creditsBodyParams, stepperData, comment } = this.state;
    const { submit_button } = issueInfo;
    let data = {};
    let url = urlStr ? urlStr : submit_button.url;

    if (
      issueInfo.comment_box &&
      !checkIfOptional(issueInfo.comment_box, comment)
    ) {
      this.setState({
        showOptionalError: true,
        optionalErrorText: 'This field is mandatory',
      });
      return;
    }

    Object.assign(data, params, creditsBodyParams, stepperData);
    data['order_id'] = orderId;
    sendFormData(url, reasonId, data);
  };

  handleStepperSubmission = (isStepperSubmit, url, params) => {
    this.setState({
      radio: null,
      selectedRadioOption: '',
      creditsBodyParams: null,
      showCreditOptionsTemp: false,
      stepperData: params,
    });

    if (isStepperSubmit !== undefined) {
      this.setState({
        showRadio: true,
        showNext: this.props.isResolutionService,
      });
    }
    // this.timerId1 = setTimeout(() => {
    //   this.getCreditOptions(url, isStepperSubmit, params);
    // }, 0);
  };

  getCreditOptions = (url, isStepperSubmit, params) => {
    const { orderId, reasonId, getCreditOptions, issueInfo } = this.props;
    const { selectedRadioOption } = this.state;
    let data = {},
      radioData;
    data['order_id'] = orderId;
    // if (radio) {
    radioData = getFormData(issueInfo.radio, selectedRadioOption);
    // }

    Object.assign(data, params, radioData);

    getCreditOptions(url, reasonId, data).then((res) => {
      // if (isStepperSubmit) {
      //   this.setState({
      //     showCreditOptionsTemp: false,
      //     radio: res.radio,
      //   });
      // } else {
      this.setState({
        creditsBodyParams: data,
        showCreditOptionsTemp: true,
      });
      // }
    });
  };

  selectOption = (radio, selectedRadioOption) => {
    this.setState({
      showCreditOptionsTemp: false,
      selectedRadioOption: '',
    });
    this.timerId2 = setTimeout(() => {
      this.setState({
        selectedRadioOption: selectedRadioOption,
        showCreditOptionsTemp: true,
      });
      this.getCreditOptions(radio.url);
    }, 0);
  };

  openImageInNewTab = (image) => {
    window.open(image);
  };

  handleCardLink = (card) => {
    const { handleCardLink } = this.props;
    if (card.show_dominos_ticket) {
      return handleCardLink(card);
    }
    card.url && this.openImageInNewTab(card.url);
  };

  evaluate = () => {
    const { orderId, cartId, complaintType } = this.props;
    this.setState({
      isLoading: true,
    });
    const dataForEvaluate = {
      order_id: orderId,
      cart_id: cartId,
      complaint_type: complaintType,
      selected_items: [],
      is_approved_complaint: false,
    };
    return reasonModel
      .evaluateResolution(dataForEvaluate)
      .then((response) => {
        if (!response) return null;
        if (response && response.isError === true) {
          this.setState({
            isLoading: false,
            isError: true,
            errorMessage: 'Something went wrong',
          });
        } else {
          this.setState({
            isLoading: false,
            showResolutionOptions: true,
            resolutionOptionDetails: response,
          });
        }
        return response;
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          isError: true,
          errorMessage: 'Something went wrong',
        });
      });
  };

  resolve = (resolutionOption) => {
    const { orderId, cartId, complaintType } = this.props;
    const { resolutionOptionDetails } = this.state;
    const selectedItems = [];
    this.setState({
      isLoading: true,
    });
    const dataForResolve = {
      complaint_id: resolutionOptionDetails?.complaint_id,
      resolution: resolutionOption?.resolution,
      sub_resolution: resolutionOption?.sub_resolution || null,
      order_id: orderId,
      cart_id: cartId,
      complaint_type: complaintType,
      selected_items: selectedItems,
      is_approved_complaint: false,
    };
    return reasonModel
      .createResolution(dataForResolve)
      .then((response) => {
        if (!response) return null;

        if (response && response.isError === true) {
          this.setState({
            isLoading: false,
            isError: true,
            errorMessage: 'Something went wrong',
          });
        } else {
          this.setState({
            isLoading: false,
            showSuccessScreen: true,
            resolutionSuccessDetails: response,
          });
        }
        return response;
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          isError: true,
          errorMessage: 'Something went wrong',
        });
      });
  };

  render() {
    const {
      issueInfo,
      orderId,
      userId,
      cartId,
      complaintType,
      isDisabled,
      creditOptions,
      handleCardLink,
      isResolutionService,
      goBack,
      mandateImageCheck,
    } = this.props;
    const {
      showCreditOptionsTemp,
      radio,
      showOptionalError,
      optionalErrorText,
      showRadio,
      showNext,
      showResolutionOptions,
      resolutionOptionDetails,
      showSuccessScreen,
      resolutionSuccessDetails,
      isError,
      isLoading,
      errorMessage,
    } = this.state;
    if (!issueInfo) return null;

    if (isLoading) return <Loader />;
    if (isError)
      return <EmptyState img={InvalidSearchImg} heading={errorMessage} />;
    return (
      <div className='raiseIssueContainer'>
        {isResolutionService && (showSuccessScreen || showResolutionOptions) ? (
          showSuccessScreen ? (
            <SuccessScreen details={resolutionSuccessDetails} goBack={goBack} />
          ) : (
            <div className='raiseIssueContent'>
              <ActionOptions
                setShowResolutionOptions={() => {
                  this.setState({
                    showResolutionOptions: false,
                  });
                }}
                resolutionOptionDetails={resolutionOptionDetails}
                resolve={this.resolve}
                isDisabled={isLoading}
                orderId={orderId}
                cartId={cartId}
                userId={userId}
                complaintType={complaintType}
              />
            </div>
          )
        ) : (
          <div className='raiseIssueContent'>
            {issueInfo.card && (
              <div className='pb20'>
                <Card
                  content={issueInfo.card}
                  onClick={this.handleCardLink.bind(this, issueInfo.card)}
                />
              </div>
            )}
            {issueInfo.stepper && issueInfo.stepper.source.length && (
              <Stepper
                orderId={orderId}
                userId={userId}
                stepperData={issueInfo.stepper.source}
                handleStepperSubmission={this.handleStepperSubmission}
              />
            )}
            {issueInfo.radio && showRadio && (
              <div className='pt20'>
                {issueInfo.radio.title && (
                  <Heading title={issueInfo.radio.title.text} />
                )}
                <RadioGroup
                  items={issueInfo.radio.source}
                  selectOption={this.selectOption.bind(this, issueInfo.radio)}
                />
              </div>
            )}
            {showCreditOptionsTemp && creditOptions && (
              <div className='pt20'>
                <CreditDetails
                  creditOptions={creditOptions}
                  sendFormData={this.sendFormData}
                  orderId={orderId}
                  isDisabled={isDisabled}
                  handleCardLink={handleCardLink}
                />
              </div>
            )}
            {issueInfo.comment_box && (
              <div className='pt10'>
                <Textarea
                  showBtn={false}
                  placeholder={issueInfo.comment_box.placeholder}
                  height='15vh'
                  onChange={this.addComment}
                  error={showOptionalError}
                  errorText={optionalErrorText}
                />
              </div>
            )}
            {isResolutionService && showNext && mandateImageCheck && (
              <div>
                <Footer
                  submitBtnTitle='Next'
                  btnBgColor='#0C831F'
                  sendFormData={this.evaluate}
                  isDisabled={isLoading}
                />
              </div>
            )}

            {issueInfo.submit_button ? (
              <Footer
                issueInfo={issueInfo}
                isDisabled={isDisabled}
                sendFormData={this.sendFormData}
              />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}
